import { render, staticRenderFns } from "./editclassification.vue?vue&type=template&id=5d482efe"
import script from "./editclassification.vue?vue&type=script&lang=js"
export * from "./editclassification.vue?vue&type=script&lang=js"
import style0 from "./editclassification.vue?vue&type=style&index=0&id=5d482efe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports